import { Link } from "react-router-dom";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { BLOG_POSTS } from "../data/content";
import { ArrowUpRight } from "lucide-react";
import { PillButton } from "../components/PillButton";

export default function BlogPreview() {
  const posts = BLOG_POSTS.slice(0, 3);
  return (
    <section className="py-24 md:py-32 bg-white" data-testid="blog-preview-section">
      <div className="container-x">
        <div className="md:flex items-end justify-between mb-14 gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <p className="font-heading font-bold uppercase tracking-[0.2em] text-sm text-[#0033A2] mb-4">
                From the blog
              </p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading font-extrabold tracking-tight text-4xl md:text-6xl leading-[0.95]">
                Ideas for better communities.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <PillButton to="/blog" variant="ghost" testid="blog-preview-viewall" className="mt-6 md:mt-0">
              View all articles <ArrowUpRight size={18} strokeWidth={2.5} />
            </PillButton>
          </Reveal>
        </div>

        <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <StaggerItem key={p.slug}>
              <Link
                to={`/blog/${p.slug}`}
                className="group block h-full"
                data-testid={`blog-preview-card-${i}`}
              >
                <div className="h-full bg-brand-light rounded-3xl overflow-hidden border-2 border-transparent transition-all duration-300 group-hover:border-black group-hover:-translate-y-2 group-hover:shadow-hard-sm">
                  <div className="overflow-hidden">
                    <img
                      src={`${p.cover}?auto=format&fit=crop&w=800&q=80`}
                      alt={p.title}
                      className="w-full h-52 object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-3 text-sm font-semibold text-[#0033A2] mb-3">
                      <span className="bg-white border-2 border-[#0033A2] rounded-full px-3 py-0.5 text-xs uppercase tracking-wide">
                        {p.category}
                      </span>
                      <span className="text-black/50">{p.read}</span>
                    </div>
                    <h3 className="font-heading font-bold text-xl tracking-tight leading-snug group-hover:text-[#0033A2] transition-colors">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-black/60 font-medium text-sm leading-relaxed line-clamp-2">
                      {p.excerpt}
                    </p>
                  </div>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
